import {
  Link as ReactRouterLink,
  type LinkProps as ReactRouterLinkProps
} from "react-router-dom"

interface LinkProps extends Omit<ReactRouterLinkProps, "state"> {
  /**
   * By default, our routing restores the scroll position of each screen as it was the last time it was was shown.
   * If you want to opt-out of this, perhaps because this is a screen that shows important controls at the top, provide this attribute.
   */
  scrollToTop?: boolean
}

export function Link(props: LinkProps) {
  const { scrollToTop = false } = props

  const state: LinkState = { scrollToTop }

  return <ReactRouterLink {...props} state={state} />
}

interface LinkState {
  scrollToTop: boolean
}

export function isLinkState(obj: unknown): obj is LinkState {
  return !!obj && typeof obj === "object" && "scrollToTop" in obj
}
